import styled, {css} from "styled-components";

interface IProgressPieDefaultBoxProps {
    bigSize: boolean;
    animationProgressDisabled: boolean;
}

export const ProgressPieDefaultBox = styled.div<IProgressPieDefaultBoxProps>`
    width: 3rem;
    height: 3rem;
    transition: all 0.4s ease-in;
    margin: ${props => props.bigSize ? "1.2" : "0.4"}rem;
    position: relative;
    svg {
        background: transparent;
        border-radius: 50%;
        display: block;
        overflow: visible;
    }
    circle#grey_outline {
        fill: grey;
    }
    circle#yellow_progress {
        transform-origin: center;
        transform: rotate(-90deg);
        fill: transparent;
        stroke: #FFCA4F;
        ${props => props.animationProgressDisabled ? null : css`
            transition:  stroke-dasharray 0.2s ease-in, stroke 0.2s ease-in;
        ` }
    }
    circle#blue_inline {
        fill: blue;
    }
`;